export type OnboardingStepNames = 'ADD_A_PRESCRIPTION' | 'VERIFY_WORK_EMAIL' | 'CREATE_ACCOUNT' | 'INSURANCE';
export interface OnboardingStep {
  label: string;
  component: string;
}

export type PromoOnboardingSteps = { [key in OnboardingStepNames]?: OnboardingStep };

// The component file path should be relative to components/Pages/PromoOnboardingSteps/index
// This object's keys need to match the steps specified in wallet-service.onboardingSteps
export const PROMO_ONBOARDING_STEPS: PromoOnboardingSteps = {
  ADD_A_PRESCRIPTION: {
    label: 'Add a Prescription',
    component: './OnboardingSteps/TransferPrescriptions/container',
  },
  CREATE_ACCOUNT: {
    label: 'Create Account',
    component: '../../GetStarted/OnboardingSteps/ProfileStep/index',
  },
  INSURANCE: {
    label: 'Insurance',
    component: './OnboardingSteps/AddInsurance/container',
  },
};

export const calculateOnboardingSteps = (onboardingSteps: {
  steps: OnboardingStepNames[];
  hidden?: OnboardingStepNames[];
}) => {
  if (!onboardingSteps?.steps || !Array.isArray(onboardingSteps?.steps)) return null;
  return onboardingSteps.steps.reduce<OnboardingStep[]>((transformedSteps, stepName) => {
    if (PROMO_ONBOARDING_STEPS.hasOwnProperty(stepName)) {
      transformedSteps.push(PROMO_ONBOARDING_STEPS[stepName]!);
    }
    return transformedSteps;
  }, []);
};
